import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Formik } from 'formik';
import { useQuery, useMutation } from '@apollo/client';
import toast from 'react-hot-toast';

import DataState from '../DataState';
import {
  TitleContainer,
  Title,
} from '../../elements';

import Form from './Form';
import { OWNER_PORTAL_USER, UPDATE_OWNER_PORTAL_USER } from './queries';
import { userSchema } from './schemas';

const EditUser = () => {
  const [formSubmitting, setFormSubmitting] = useState(false);
  const navigate = useNavigate();

  const { id } = useParams();

  const { data, loading, error } = useQuery(OWNER_PORTAL_USER, {
    variables: { id }
  });

  const [updateOwnerPortalUser] = useMutation(UPDATE_OWNER_PORTAL_USER, {
    onCompleted: () => {
      toast('User Updated');
      navigate('/users');
    }
  });

  if (loading && !data) return <DataState.Loading />;
  if (error) return <DataState.Error error={error} />;

  const handleSubmit = values => {
    setFormSubmitting(true);

    const {
      firstName, lastName, email, mobilePhone, officePhone,
      ...ownerPortalUser
    } = values;

    ownerPortalUser.portalUserAttributes = {
      firstName, lastName, email, mobilePhone, officePhone
    };

    updateOwnerPortalUser({ variables: ownerPortalUser });
  };

  const portalUser = data.ownerPortalUser.portalUser;

  return (
    <>
      <Helmet>
        <title>Edit User - {portalUser.fullName}</title>
      </Helmet>

      <TitleContainer>
        <Title>Edit User - {portalUser.fullName}</Title>
      </TitleContainer>

      {formSubmitting ? <DataState.Loading /> : (
        <Formik
          initialValues={{
            id: data.ownerPortalUser.id,
            firstName: portalUser.firstName,
            lastName: portalUser.lastName,
            email: portalUser.email,
            mobilePhone: portalUser.mobilePhone?.value || '',
            officePhone: portalUser.officePhone?.value || '',
            role: data.ownerPortalUser.role,
          }}
          validationSchema={userSchema}
          onSubmit={handleSubmit}
        >
          <Form formSubmitting={formSubmitting} />
        </Formik>
      )}
    </>
  );
};

export default EditUser;
